import './breadcrumb.less';

import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Breadcrumb extends Component {
  static propTypes = {
    // 获取关键词
    keyword: PropTypes.string,
    // 作品案例结果数
    total: PropTypes.number,
  };
  render() {
    const { keyword, total } = this.props;
    return (
      <div className="breadcrumb-container">
        <ul className="breadcrumb-list">
          <li className="breadcrumb-item">
            <span>
              <a className="link" href="/preview/" target="_blank">
                作品案例
              </a>
            </span>
          </li>
          <li className="breadcrumb-item">
            <span className="line">&nbsp;/&nbsp;</span>
          </li>
          <li className="breadcrumb-item">
            <h1 className="keyword">
              搜索“
              {keyword}”
            </h1>
          </li>
          <li className="breadcrumb-item">
            <span>
              共
              <span className={total > 0 ? 'hasValue' : 'number'}>{total}</span>
              个结果
            </span>
          </li>
        </ul>
      </div>
    );
  }
}

export default Breadcrumb;
